export { default } from "./upsPaymentConfirmation";
